<div role="progressbar" :class="classes_" :style="styles_" class="mdc-linear-progress">
    <div class="mdc-linear-progress__buffering-dots"></div>
    <div ref="buffer" class="mdc-linear-progress__buffer"></div>
    <div ref="primary" class="mdc-linear-progress__bar mdc-linear-progress__primary-bar">
        <span class="mdc-linear-progress__bar-inner"></span>
    </div>
    <div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
        <span class="mdc-linear-progress__bar-inner"></span>
    </div>
</div>
